import React from 'react';
import { Box } from '@mui/material';

import Markdown from '../markdown';
import RenderIf from '../../../renderIf';
import {
    SingleLineText,
    MultiLineText,
    SingleChoiceDropdown,
    DropdownMultiple,
    Radio,
    Checkbox,
    DatePicker,
    File,
    Signature,
} from './questionTypes';
import { questionTypes } from '../../../../utils/enums';

const Question = (props) => {
    const { question, appInstId } = props;

    return (
        <Box
            sx={{
                margin: '3rem 1rem',
            }}
        >
            <Markdown
                sx={{
                    fontSize: '13px',
                }}
            >
                {question?.text?.['en-US']}
            </Markdown>

            <RenderIf isTrue={question.questionType === questionTypes.SingleLinePlainText}>
                <SingleLineText
                    question={question}
                    readOnly
                />
            </RenderIf>

            <RenderIf isTrue={question.questionType === questionTypes.MultiLinePlainText}>
                <MultiLineText
                    question={question}
                    readOnly
                />
            </RenderIf>

            <RenderIf isTrue={question.questionType === questionTypes.Dropdown}>
                <SingleChoiceDropdown
                    question={question}
                    readOnly
                />
            </RenderIf>

            <RenderIf isTrue={question.questionType === questionTypes.Radio}>
                <Radio
                    question={question}
                    readOnly
                />
            </RenderIf>

            <RenderIf isTrue={question.questionType === questionTypes.Checkbox}>
                <Checkbox
                    question={question}
                    readOnly
                />
            </RenderIf>

            <RenderIf isTrue={question.questionType === questionTypes.DatePicker}>
                <DatePicker
                    question={question}
                    readOnly
                />
            </RenderIf>

            <RenderIf isTrue={question.questionType === questionTypes.FileUpload}>
                <File
                    question={question}
                    downloadOnly
                />
            </RenderIf>

            <RenderIf isTrue={question.questionType === questionTypes.SignaturePad}>
                <Signature
                    question={question}
                    appInstId={appInstId}
                    readOnly
                />
            </RenderIf>

            <RenderIf isTrue={question.questionType === questionTypes.DropdownMultichoice}>
                <DropdownMultiple
                    question={question}
                    readOnly
                />
            </RenderIf>
        </Box>
    );
};

export default Question;
